'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isFinite = require('lodash/isFinite');

var _isFinite2 = _interopRequireDefault(_isFinite);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _executionEnvironment = require('../../../util/execution-environment');

var _customSelectLocal = require('./custom-select.local.css');

var _customSelectLocal2 = _interopRequireDefault(_customSelectLocal);

var _icon = require('../../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable no-plusplus, array-callback-return */


var ARROW_LEFT_KEY = 37;
var ARROW_UP_KEY = 38;
var ARROW_RIGHT_KEY = 39;
var ARROW_DOWN_KEY = 40;
var SPACEBAR_KEY = 32;
var TAB_KEY = 9;
var ESCAPE_KEY = 27;
var ENTER_KEY = 13;

var Dropdown = exports.Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this));

    _this.setFocus = function (idx) {
      _this.setState({
        currentIndex: idx
      });

      if (_this.optionsElements[idx]) {
        _this.optionsElements[idx].focus();
      }
    };

    _this.resetFocus = function () {
      _this.optionsElements.map(function (el) {
        return el.blur();
      });
    };

    _this.makeSelection = function (val) {
      _this.props.makeSelection(val);
    };

    _this.handleDocumentKeydown = function (ev) {
      var keyCode = ev.keyCode;
      var total = _this.optionsElements.length - 1;
      var currentIndex = _this.state.currentIndex;

      var disabledOptionIndexes = _this.props.options.reduce(function (acc, option, idx) {
        if (option.disabled) {
          return acc.concat(idx);
        }

        return acc;
      }, []);

      if (disabledOptionIndexes.length === _this.optionsElements.length) {
        return null;
      }

      if (keyCode === ARROW_DOWN_KEY || keyCode === ARROW_RIGHT_KEY || keyCode === TAB_KEY) {
        ev.preventDefault();
        var nextIndex = currentIndex + 1;

        while (disabledOptionIndexes.indexOf(nextIndex) > -1) {
          nextIndex++;
        }

        if (nextIndex <= total) {
          _this.setFocus(nextIndex);
        }
      }

      if (keyCode === ARROW_LEFT_KEY || keyCode === ARROW_UP_KEY) {
        ev.preventDefault();

        var _nextIndex = currentIndex - 1;

        while (disabledOptionIndexes.indexOf(_nextIndex) > -1) {
          _nextIndex--;
        }

        if (_nextIndex >= 0) {
          _this.setFocus(_nextIndex);
        }
      }

      if (keyCode === SPACEBAR_KEY || keyCode === ENTER_KEY) {
        ev.preventDefault();

        _this.makeSelection(_this.props.options[currentIndex].value);
      }

      if (keyCode === ESCAPE_KEY) {
        ev.preventDefault();

        _this.props.close();
      }
    };

    _this.handleClickOutside = function () {
      _this.props.close();
    };

    _this.optionsElements = [];
    _this.state = {
      currentIndex: 0
    };
    return _this;
  }

  _createClass(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_executionEnvironment.canUseDOM && this.optionsElements.length) {
        this.optionsElements[0].focus();
        document.addEventListener('keydown', this.handleDocumentKeydown);
        document.addEventListener('mousemove', this.resetFocus);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (_executionEnvironment.canUseDOM) {
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        document.removeEventListener('mousemove', this.resetFocus);
      }
    } // eslint-disable-next-line consistent-return

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          selectedOption = _props.selectedOption,
          dropdownClassName = _props.dropdownClassName,
          optionClassName = _props.optionClassName,
          options = _props.options,
          id = _props.id,
          theme = _props.theme,
          maxDropdownHeight = _props.maxDropdownHeight;
      return _react2.default.createElement('ul', {
        style: (0, _isFinite2.default)(maxDropdownHeight) ? {
          maxHeight: maxDropdownHeight,
          overflowY: 'auto'
        } : {},
        id: id,
        'data-auto': 'customSelectDropdown',
        className: (0, _classnames2.default)(_customSelectLocal2.default.dropdown, theme && _customSelectLocal2.default['theme--' + theme], dropdownClassName),
        ref: function ref(el) {
          _this2.dropdown = el;
        }
      }, options.map(function (_ref, idx) {
        var value = _ref.value,
            disabled = _ref.disabled,
            icon = _ref.icon,
            iconSize = _ref.iconSize,
            label = _ref.label,
            className = _ref.className;
        return _react2.default.createElement('li', {
          key: value,
          id: value,
          'data-auto': 'customSelectOption',
          className: (0, _classnames2.default)(_customSelectLocal2.default.option, optionClassName)
        }, _react2.default.createElement('button', {
          ref: function ref(el) {
            _this2.optionsElements[idx] = el;
          },
          'data-auto': 'dropdownOption' + idx,
          className: (0, _classnames2.default)(_customSelectLocal2.default.optionButton, selectedOption.value === value && _customSelectLocal2.default.selected, className),
          onClick: function onClick() {
            return _this2.makeSelection(value);
          },
          disabled: disabled
        }, _react2.default.createElement('span', {
          className: _customSelectLocal2.default.optionButtonContent
        }, _react2.default.createElement('span', {
          className: _customSelectLocal2.default.optionLabel
        }, label), icon && _react2.default.createElement(_icon2.default, {
          icon: icon,
          size: iconSize || 'large',
          className: _customSelectLocal2.default.optionIcon
        }))));
      }));
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.propTypes = {
  theme: _propTypes2.default.string,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    label: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string,
    className: _propTypes2.default.string,
    iconSize: _propTypes2.default.oneOf(['xsmall', 'small', 'normal', 'medium', 'large']),
    disabled: _propTypes2.default.bool
  })).isRequired,
  selectedOption: _propTypes2.default.shape({
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    label: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string,
    iconSize: _propTypes2.default.oneOf(['xsmall', 'small', 'normal', 'medium', 'large']),
    disabled: _propTypes2.default.bool
  }).isRequired,
  maxDropdownHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  dropdownClassName: _propTypes2.default.string,
  makeSelection: _propTypes2.default.func.isRequired,
  close: _propTypes2.default.func.isRequired,
  optionClassName: _propTypes2.default.string,
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
};
exports.default = (0, _reactOnclickoutside2.default)(Dropdown);